"use client";

import { useEffect } from "react";

import { useConsent } from "@/components/consent-provider";

const MS_ADS_TRACKING_ID = 151018077;

type UetOptions = {
  ti: number;
  enableAutoSpaTracking: boolean;
  q?: unknown[];
  ts?: number;
};

type UetQueue = unknown[];
type UetInstance = {
  push: (...args: unknown[]) => void;
};

declare global {
  interface Window {
    uetq?: UetQueue | UetInstance;
    UET?: {
      new (options: UetOptions): UetInstance;
    };
  }
}

export function MicrosoftAdsScripts() {
  const { consent } = useConsent();

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const existingScript = document.getElementById("ms-ads-bat-js");

    if (consent !== "all") {
      if (existingScript) {
        existingScript.remove();
      }
      window.uetq = undefined;
      return;
    }

    if (existingScript) {
      return;
    }

    const script = document.createElement("script");
    script.id = "ms-ads-bat-js";
    script.async = true;
    script.src = "https://bat.bing.net/bat.js";

    const initUet = () => {
      if (!window.UET) {
        return;
      }

      const queue = window.uetq;
      const options: UetOptions = {
        ti: MS_ADS_TRACKING_ID,
        enableAutoSpaTracking: true,
        ts: Date.now(),
        q: Array.isArray(queue) ? queue : [],
      };
      window.uetq = new window.UET(options);
      window.uetq.push("pageLoad");
    };

    script.addEventListener("load", initUet);

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript?.parentNode?.insertBefore(script, firstScript);

    return () => {
      script.removeEventListener("load", initUet);
    };
  }, [consent]);

  return null;
}
